export default __webpack_public_path__ + "images/59aa8704101a3487a61ad6a5f8c0751c-adoption-center-banner-text-667-spanish.png";